import _slicedToArray from "/Users/henry/Documents/GitHub/creative-coding-2022/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/Users/henry/Documents/GitHub/creative-coding-2022/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/Users/henry/Documents/GitHub/creative-coding-2022/node_modules/@babel/runtime/regenerator/index.js";
import React, { useState, useEffect } from "react";
import ReactReplView from "./ReactReplView";
import useReactReplJS from "./useReactReplJS";
import prettyFormat from "pretty-format";
var AsyncFunction = Object.getPrototypeOf( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}))).constructor;

function scopeEval(scope, script) {
  script = script.trim().replace(/^var /, "").replace(/^let /, "").replace(/^const /, "");
  return AsyncFunction("return (" + script + ")").bind(scope)();
}

function execAndGetLine(_x) {
  return _execAndGetLine.apply(this, arguments);
}

function _execAndGetLine() {
  _execAndGetLine = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(execLine) {
    var evalOutput;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (execLine.trim()) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", []);

          case 2:
            _context4.prev = 2;
            _context4.next = 5;
            return scopeEval(window, execLine);

          case 5:
            evalOutput = _context4.sent;
            return _context4.abrupt("return", {
              type: "output",
              value: prettyFormat(evalOutput)
            });

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](2);
            return _context4.abrupt("return", {
              type: "error",
              value: _context4.t0
            });

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 9]]);
  }));
  return _execAndGetLine.apply(this, arguments);
}

export var ReactReplJS = function ReactReplJS(_ref2) {
  var title = _ref2.title,
      tabs = _ref2.tabs,
      stealFocus = _ref2.stealFocus,
      selectedTab = _ref2.selectedTab,
      onChangeTab = _ref2.onChangeTab,
      _ref2$initialLines = _ref2.initialLines,
      initialLines = _ref2$initialLines === void 0 ? [] : _ref2$initialLines,
      _ref2$initiallyExecut = _ref2.initiallyExecute,
      initiallyExecute = _ref2$initiallyExecut === void 0 ? [] : _ref2$initiallyExecut,
      height = _ref2.height,
      _ref2$submitCodeRef = _ref2.submitCodeRef,
      submitCodeRef = _ref2$submitCodeRef === void 0 ? null : _ref2$submitCodeRef;

  var _useState = useState(initialLines),
      _useState2 = _slicedToArray(_useState, 2),
      lines = _useState2[0],
      setLines = _useState2[1];

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(execLine) {
      var newLines;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              newLines = lines.concat([{
                type: "input",
                value: execLine
              }]);
              setLines(newLines);

              if (execLine.trim()) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              _context2.t0 = setLines;
              _context2.t1 = newLines;
              _context2.next = 8;
              return execAndGetLine(execLine);

            case 8:
              _context2.t2 = _context2.sent;
              _context2.t3 = [_context2.t2];
              _context2.t4 = _context2.t1.concat.call(_context2.t1, _context2.t3);
              (0, _context2.t0)(_context2.t4);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  if (submitCodeRef) submitCodeRef.current = onSubmit;
  useEffect(function () {
    ;

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var lines, _iterator, _step, execLine;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(initiallyExecute.length === 0)) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              lines = [];
              _iterator = _createForOfIteratorHelper(initiallyExecute);
              _context3.prev = 4;

              _iterator.s();

            case 6:
              if ((_step = _iterator.n()).done) {
                _context3.next = 18;
                break;
              }

              execLine = _step.value;
              lines.push({
                type: "input",
                value: execLine
              });

              if (execLine.trim()) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("continue", 16);

            case 11:
              _context3.t0 = lines;
              _context3.next = 14;
              return execAndGetLine(execLine);

            case 14:
              _context3.t1 = _context3.sent;

              _context3.t0.push.call(_context3.t0, _context3.t1);

            case 16:
              _context3.next = 6;
              break;

            case 18:
              _context3.next = 23;
              break;

            case 20:
              _context3.prev = 20;
              _context3.t2 = _context3["catch"](4);

              _iterator.e(_context3.t2);

            case 23:
              _context3.prev = 23;

              _iterator.f();

              return _context3.finish(23);

            case 26:
              setLines(lines);

            case 27:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 20, 23, 26]]);
    }))();
  }, []);
  return /*#__PURE__*/React.createElement(ReactReplView, {
    title: title,
    tabs: tabs || ["Javascript"],
    stealFocus: stealFocus,
    selectedTab: selectedTab || "Javascript",
    onChangeTab: onChangeTab,
    onSubmit: onSubmit,
    height: height,
    lines: lines,
    onClear: function onClear() {
      return setLines([]);
    }
  });
};
export { ReactReplView, useReactReplJS };
export default ReactReplJS;